import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { H3 } from '@osmosis/tailwind-ui/components/Text';

import Image from 'next/image';
import React from 'react';

import { FormattedMessage } from 'react-intl';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { ModalHookProps } from '../../../hooks/useModal';
import threeCardImage from '../../../assets/three-card-videos.png';

type Props = {
  newPlaylistModal: ModalHookProps;
};

/**
 * Component to render when the user has no playlists yet.
 */
const EmptyPlaylists = (props: Props) => {
  const { newPlaylistModal } = props;
  return (
    <Flex
      className={`flex-col justify-center items-center gap-4 min-h-[600px]`}
    >
      <Image
        alt="Empty playlist image"
        src={threeCardImage}
        width={421}
        height={283}
      />

      <Flex className={`items-center flex-col gap-2`}>
        <H3>
          <FormattedMessage
            defaultMessage="Create a new playlist"
            id="playlist_page.empty.heading"
          />
        </H3>
        <P>
          <FormattedMessage
            defaultMessage="Playlists you create or save to watch later will show up on the menu on the left."
            id="playlist_page.empty.text"
          />
        </P>
      </Flex>
      <Button
        onClick={newPlaylistModal.show}
        data-testid="empty-playlist-new-playlist-btn"
        startIcon={<Icon icon={faPlus} />}
      >
        <FormattedMessage
          defaultMessage="New playlist"
          id="playlist_page.empty.button_text"
        />
      </Button>
    </Flex>
  );
};

export default EmptyPlaylists;
